import { Form, Select, type SelectProps } from "antd";
import { useEffect, useMemo } from "react";
import type { FormInstance, Rule } from "antd/es/form";
import type { FilterFunc } from "rc-select/lib/Select";
import type { DefaultOptionType } from "antd/es/cascader";
import type { Project } from "../../app/generated-axios-client";
import type { IntlShape } from "@formatjs/intl";
import { useWatch } from "antd/es/form/Form";

const projectSelectOptions = (projectItems: Project[]) =>
	projectItems.map((item) => ({
		key: item.id,
		value: item.id,
		label: item.name,
	}));

const projectSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
	const search = input.toLowerCase();
	const value = option?.label?.toString().toLowerCase?.() ?? "";
	return value.includes(search);
};

type ProjectSelectorFormItemProps = {
	intl: IntlShape;
	projectItems: Project[];
	rules?: Rule[];
	placeholder?: string | boolean;
	selectProps?: SelectProps<string>;
	form: FormInstance;
};

export const ProjectSelectorFormItem = (
	props: ProjectSelectorFormItemProps,
) => {
	const {
		intl,
		projectItems,
		rules = [],
		placeholder = false,
		selectProps,
		form,
	} = props;

	const options = useMemo(
		() => projectSelectOptions(projectItems) ?? [],
		[projectItems],
	);

	useEffect(() => {
		if (
			options.filter((item) => {
				return item.key === form.getFieldValue("project");
			}).length <= 0
		) {
			form.setFieldValue("project", undefined);
		}
	}, [options, form]);

	const isClientSelected = useWatch(["client"], form);

	return (
		<Form.Item
			name="project"
			label={intl.formatMessage({ id: "project_label" })}
		>
			<Select
				placeholder={placeholder}
				disabled={!isClientSelected}
				showSearch
				allowClear
				options={options}
				filterOption={projectSearchHandler}
				{...selectProps}
			/>
		</Form.Item>
	);
};
